import React from 'react';
import PropTypes from 'prop-types';
import AuthHeader from './AuthHeader';
import './AuthLayout.less';

const Layout = ({ children }) => (
  <div className="auth-layout">
    <AuthHeader />
    <div className="main-content">
      {children}
    </div>
  </div>
);

Layout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Auth/AuthLayout.js